<template>
  <section class="verification-phone">
      <div>
          <NavigationBar />
          <div class="uk-section uk-padding-remove-top uk-margin-top">
              <div class="uk-container uk-margin-top">
                  <h3>Verification Phone</h3>
                  <form @submit.prevent="submitCode()">
                    <div class="uk-flex uk-flex-left" uk-grid>
                        <div class="uk-width-1-1">
                            <div class="text-color-success">A verification code has been sent to your mobile number</div>
                        </div>
                        <div class="uk-width-1-1">
                            <div>Mobile phone number</div>
                            <div class="uk-text-bold">{{ GET_USER.phone }}</div>
                        </div>
                        <div class="uk-width-1-1">
                            <div>Enter the verification code</div>
                            <div class="uk-width-1-4@s">
                                <input type="text" class="uk-input" v-model="code" />
                            </div>
                        </div>
                        <div class="uk-width-1-1">
                            <div>Didn't get the code? <span v-if="durationOtp > 0">{{ `Wait ${durationOtp} seconds` }}</span><span v-else><a href="javascript:void(0)" @click="getCode()">Resend</a></span></div>
                            <div uk-grid>
                                <div class="uk-width-1-1@s uk-width-1-5@m">
                                    <button :class="`uk-button uk-button-primary uk-width-1-1 ${disabledButton ? 'button-disabled' : ''}`" :disabled="disabledButton" type="submit">Verification</button>
                                </div>
                                <div class="uk-width-1-1@s uk-width-1-4@m">
                                    <router-link class="uk-button uk-button-default uk-width-1-1" to="/profile">Change Mobile Number</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                  </form>
              </div>
          </div>
          <Footer />
      </div>
  </section>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import { mapGetters, mapMutations } from 'vuex';
import $axios from "@/api.js"
import UIkit from "uikit";
export default {
    components: {
        NavigationBar,
        Footer
    },
    data() {
        return {
            code: '',
        }
    },
    mounted() {
        if (!this.IS_AUTH) {
            this.$router.push(`/?login=true&back=${window.location.origin + '/profile'}`);
        } else {
            // this.getCode()
        }
    },
    computed: {
        ...mapGetters('auth', ['IS_AUTH', 'GET_USER']),
        ...mapGetters(['GET_DURATION_OTP']),
        durationOtp: {
            get() {
                return this.GET_DURATION_OTP
            },
            set(val) {
                this.SET_DURATION_OTP(val)
            }
        },
        disabledButton() {
            return this.code == ''
        }
    },
    methods: {
        ...mapMutations('auth', ['SET_USER']),
        ...mapMutations(['SET_DURATION_OTP']),
        getCode() {
            if (this.durationOtp == 0) {
                $axios.post('customer/auth/request_otp_phone', {
                    id_cust: this.GET_USER.id
                }).then((res) => {
                    if (res.status == 200) {
                        const data = res.data
                        if (data.success == 1) {
                            this.durationOtp = 120
                            UIkit.notification({
                                status: 'success',
                                message: 'Verification code has been sent successfully'
                            })
                        } else {
                            console.warn(data.data)
                            UIkit.notification({
                                status: 'danger',
                                message: 'Something went wrong!',
                            })      
                        }
                    } else {
                        console.log(`Request Code: ${res.status}`)
                        UIkit.notification({
                            status: 'danger',
                            message: 'Something went wrong!',
                        })   
                    }
                }).catch((err) => {
                    console.warn(err)
                    UIkit.notification({
                        status: 'danger',
                        message: 'Something went wrong!',
                    })
                });
            }
        },
        submitCode() {
            if (!this.disabledButton) {
                $axios.post('customer/auth/submit_otp_phone', {
                    id_cust: this.GET_USER.id,
                    code: this.code
                }).then((res) => {
                    if (res.status == 200) {
                        const data = res.data
                        if (data.success == 1) {
                            UIkit.notification({
                                status: 'success',
                                message: 'Phone number has been successfully verified!'
                            })
                            const userData = this.GET_USER
                            userData.verification_phone = 1
                            this.SET_USER(userData)
                            this.durationOtp = 0
                            this.$router.push('/profile')
                        } else {
                            UIkit.notification({
                                status: 'error',
                                message: data.msg
                            })
                        }
                    } else {
                        console.log(`Status Code ${res.status}`)
                        UIkit.notification({
                            status: 'error',
                            message: 'Something went wrong!'
                        })
                    }
                }).catch((err) => {
                   console.warn(err) 
                   UIkit.notification({
                       status: 'error',
                       message: 'Something went wrong!'
                   })
                });
            }
        }
    },
    // watch: {
    //     durationOtp: {
    //         handler(value) {
    //             if (value > 0) {
    //                 setTimeout(() => {
    //                     --this.durationOtp
    //                 }, 1000);
    //             }
    //         },
    //         immediate: true,
    //     }
    // }
}
</script>

<style lang="less" scoped>
@import "../../custom/custom.less";
.verification-phone {
    .button-disabled{
        background: #e1e1e1;
    }
}
</style>